import React from 'react';
import { Route, Routes } from "react-router-dom";
import './App.css';
import MainLayout from "./layouts/mainLayout";
import {HomePage} from "./pages/homePage";


function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<MainLayout/>}>
                    <Route index element={<HomePage/>}/>
                </Route>
            </Routes>
        </>
    );
}

export default App;
